module.exports = __webpack_public_path__ + "static/media/11_6.7f2ea565.jpg";